import { render, staticRenderFns } from "./list-customer.vue?vue&type=template&id=a6679d26&scoped=true"
import script from "./list-customer.vue?vue&type=script&lang=js"
export * from "./list-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6679d26",
  null
  
)

export default component.exports